import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useMeta } from "@/hooks/useMeta";

export default function ImpressumPage() {
  useMeta(
    "Impressum | BRIMO Immobilien NRW",
    "Impressum von BRIMO Immobilien – Bricks and Mortar Immobilien Nordrhein-Westfalen GmbH."
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Navbar />

      <section className="pt-32 pb-24" data-testid="impressum-page">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl">
          <div className="h-0.5 w-12 bg-[#E61D38] mb-6" />
          <h1
            className="text-4xl font-black text-white uppercase tracking-tight mb-10"
            style={{ fontFamily: "Montserrat, sans-serif" }}
          >
            IMPRESSUM
          </h1>

          <div className="space-y-8 text-gray-400 text-sm leading-relaxed">
            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Angaben gemäß § 5 TMG
              </h2>
              <p>
                Bricks & Mortar Immobilien Nordrhein-Westfalen GmbH
                <br />
                Wilhelmstraße 3
                <br />
                42781 Haan
                <br />
                Deutschland
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Kontakt
              </h2>
              <p>
                Telefon: 02129 / 3766829
                <br />
                E-Mail:{" "}
                <a href="mailto:info@brimo-immobilien-kreismettmann.de" className="text-[#E61D38] hover:underline">
                  info@brimo-immobilien-kreismettmann.de
                </a>
                <br />
                Website:{" "}
                <a href="https://www.brimo-immobilien-kreismettmann.de" className="text-[#E61D38] hover:underline">
                  www.brimo-immobilien-kreismettmann.de
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Handelsregister
              </h2>
              <p>
                Registergericht: Amtsgericht Kreis Mettmann
                <br />
                Registernummer: HRB 34654
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Geschäftsführung
              </h2>
              <p>Alexander Neises</p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Umsatzsteuer-Identifikationsnummer
              </h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
                <br />
                DE368586120
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Berufsbezeichnung und berufsrechtliche Regelungen
              </h2>
              <p>
                Berufsbezeichnung: Immobilienmakler
                <br />
                Zuständige Aufsichtsbehörde: Stadt Haan, Ordnungsamt
                <br /><br />
                Es gelten folgende berufsrechtliche Regelungen:
                <br />
                § 34c Gewerbeordnung (GewO)
                <br />
                Makler- und Bauträgerverordnung (MaBV)
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Berufshaftpflichtversicherung
              </h2>
              <p>
                Es besteht eine Berufshaftpflichtversicherung für die Tätigkeit als Immobilienmakler.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Streitschlichtung
              </h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#E61D38] hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                <br /><br />
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Haftung für Inhalte
              </h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
                fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidtige Tätigkeit hinweisen.
              </p>
              <p className="mt-3">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach
                den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
                jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
                umgehend entfernen.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Haftung für Links
              </h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                Urheberrecht
              </h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
